// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-page {
  padding: 0 12px 100px;
  background: #f5f0e8;
  min-height: 100vh;
}

.review-back-header {
  padding: 12px 16px;
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-color);
}

.review-back-btn {
  font-size: 14px;
  color: var(--primary);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  transition: all 0.2s;
}

.review-back-btn:hover {
  background: var(--primary-light);
}

.review-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #333;
  padding: 16px 0 12px;
  background: #f5f0e8;
}
.review-card {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 12px;
  padding: 14px 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.card-header {
  font-size: 15px;
  font-weight: 700;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.dot-orange {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #f97316;
  border-radius: 50%;
}
.score-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  gap: 8px;
}
.score-label {
  font-size: 13px;
  color: #555;
  flex-shrink: 0;
  min-width: 80px;
  max-width: 120px;
}
.score-label-detail {
  font-size: 12px;
  color: #555;
  flex: 1 1;
  line-height: 1.4;
}
.score-display {
  font-size: 13px;
  color: var(--primary);
  font-weight: 600;
  background: #fff0e5;
  padding: 2px 6px;
  border-radius: 4px;
  flex-shrink: 0;
}
.radio-group {
  display: flex;
  gap: 12px;
  align-items: center;
}
.radio-item {
  font-size: 12px;
  color: #555;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}
.radio-item input[type="radio"] {
  margin: 0;
  accent-color: var(--primary);
}
.score-select {
  flex: 1 1;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background: #f9f9f9;
  color: #333;
}
.score-select-wide {
  flex: 1 1;
  max-width: 280px;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 12px;
  background: #f9f9f9;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
}
.score-select-small {
  width: 60px;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background: #f9f9f9;
  color: #333;
}
.score-input {
  width: 50px;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background: #f9f9f9;
  color: #333;
  text-align: center;
}
.score-max {
  font-size: 12px;
  color: #999;
  flex-shrink: 0;
}
.ai-answer-box {
  background: #fff7ed;
  border: 1px solid #ffdcd0;
  border-radius: 6px;
  padding: 8px 12px;
  margin: 4px 0 8px;
}
.ai-answer-empty {
  opacity: 0.6;
}
.ai-answer-label {
  font-size: 12px;
  color: var(--primary);
  font-weight: 600;
}
.ai-answer-text {
  font-size: 12px;
  color: var(--primary);
  line-height: 1.5;
}
.review-bottom-bar {
  background: #fff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  box-shadow: 0 -4px 12px rgba(0,0,0,0.08);
}
.bottom-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.bottom-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.save-btn {
  background: #ff6f20;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.save-btn:hover { background: #e55a0f; }
.calculate-btn {
  background: #ff6f20;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.calculate-btn:hover { background: #e55a0f; }
.total-display {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}
.ability-salary-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.salary-label {
  font-size: 13px;
  color: #555;
}
.salary-input {
  width: 120px;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
}
.review-loading {
  text-align: center;
  padding: 40px;
  font-size: 16px;
  color: #666;
}
.back-home-btn {
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-left: 8px;
}
.back-home-btn:hover { background: var(--primary-hover); }

/* ===== V2 新增样式 ===== */

/* ?号帮助图标 */
.help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #e0e0e0;
  color: #666;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  margin-left: 4px;
  flex-shrink: 0;
  line-height: 1;
}
.help-icon:hover {
  background: var(--primary);
  color: #fff;
}

/* 分类小计 */
.cat-total {
  margin-left: auto;
  font-size: 12px;
  color: var(--primary);
  font-weight: 600;
}

/* 合格/不合格标签 */
.pass-tag {
  display: inline-block;
  background: var(--primary);
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}
.fail-tag {
  display: inline-block;
  background: #ef4444;
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}

/* 评分规则浮窗 */
.popover-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.popover-content {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  max-width: 500px;
  width: 90%;
  max-height: 70vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
.popover-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 700;
  color: #333;
}
.popover-close {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  padding: 4px 8px;
  border-radius: 4px;
}
.popover-close:hover {
  background: #f0f0f0;
  color: #333;
}
.popover-body pre {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 13px;
  line-height: 1.7;
  color: #444;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/AssessmentReviewPage.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,QAAQ;AACV;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,SAAO;EACP,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,kBAAkB,mBAAmB,EAAE;AACvC;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA,uBAAuB,gCAAgC,EAAE;;AAEzD,wBAAwB;;AAExB,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,8EAA8E;EAC9E,SAAS;AACX","sourcesContent":[".review-page {\n  padding: 0 12px 100px;\n  background: #f5f0e8;\n  min-height: 100vh;\n}\n\n.review-back-header {\n  padding: 12px 16px;\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.review-back-btn {\n  font-size: 14px;\n  color: var(--primary);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: var(--radius-sm);\n  transition: all 0.2s;\n}\n\n.review-back-btn:hover {\n  background: var(--primary-light);\n}\n\n.review-title {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n  padding: 16px 0 12px;\n  background: #f5f0e8;\n}\n.review-card {\n  background: #fff;\n  border-radius: 12px;\n  margin-bottom: 12px;\n  padding: 14px 16px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n.card-header {\n  font-size: 15px;\n  font-weight: 700;\n  color: #333;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.dot-orange {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  background: #f97316;\n  border-radius: 50%;\n}\n.score-row {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n  gap: 8px;\n}\n.score-label {\n  font-size: 13px;\n  color: #555;\n  flex-shrink: 0;\n  min-width: 80px;\n  max-width: 120px;\n}\n.score-label-detail {\n  font-size: 12px;\n  color: #555;\n  flex: 1;\n  line-height: 1.4;\n}\n.score-display {\n  font-size: 13px;\n  color: var(--primary);\n  font-weight: 600;\n  background: #fff0e5;\n  padding: 2px 6px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n.radio-group {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n.radio-item {\n  font-size: 12px;\n  color: #555;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n.radio-item input[type=\"radio\"] {\n  margin: 0;\n  accent-color: var(--primary);\n}\n.score-select {\n  flex: 1;\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background: #f9f9f9;\n  color: #333;\n}\n.score-select-wide {\n  flex: 1;\n  max-width: 280px;\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 12px;\n  background: #f9f9f9;\n  color: #333;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.score-select-small {\n  width: 60px;\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background: #f9f9f9;\n  color: #333;\n}\n.score-input {\n  width: 50px;\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background: #f9f9f9;\n  color: #333;\n  text-align: center;\n}\n.score-max {\n  font-size: 12px;\n  color: #999;\n  flex-shrink: 0;\n}\n.ai-answer-box {\n  background: #fff7ed;\n  border: 1px solid #ffdcd0;\n  border-radius: 6px;\n  padding: 8px 12px;\n  margin: 4px 0 8px;\n}\n.ai-answer-empty {\n  opacity: 0.6;\n}\n.ai-answer-label {\n  font-size: 12px;\n  color: var(--primary);\n  font-weight: 600;\n}\n.ai-answer-text {\n  font-size: 12px;\n  color: var(--primary);\n  line-height: 1.5;\n}\n.review-bottom-bar {\n  background: #fff;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  box-shadow: 0 -4px 12px rgba(0,0,0,0.08);\n}\n.bottom-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.bottom-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.save-btn {\n  background: #ff6f20;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.save-btn:hover { background: #e55a0f; }\n.calculate-btn {\n  background: #ff6f20;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.calculate-btn:hover { background: #e55a0f; }\n.total-display {\n  font-size: 14px;\n  color: #333;\n  font-weight: 600;\n}\n.ability-salary-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.salary-label {\n  font-size: 13px;\n  color: #555;\n}\n.salary-input {\n  width: 120px;\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n}\n.review-loading {\n  text-align: center;\n  padding: 40px;\n  font-size: 16px;\n  color: #666;\n}\n.back-home-btn {\n  background: var(--primary);\n  color: #fff;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-left: 8px;\n}\n.back-home-btn:hover { background: var(--primary-hover); }\n\n/* ===== V2 新增样式 ===== */\n\n/* ?号帮助图标 */\n.help-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #e0e0e0;\n  color: #666;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-left: 4px;\n  flex-shrink: 0;\n  line-height: 1;\n}\n.help-icon:hover {\n  background: var(--primary);\n  color: #fff;\n}\n\n/* 分类小计 */\n.cat-total {\n  margin-left: auto;\n  font-size: 12px;\n  color: var(--primary);\n  font-weight: 600;\n}\n\n/* 合格/不合格标签 */\n.pass-tag {\n  display: inline-block;\n  background: var(--primary);\n  color: #fff;\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n.fail-tag {\n  display: inline-block;\n  background: #ef4444;\n  color: #fff;\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n/* 评分规则浮窗 */\n.popover-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.popover-content {\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 70vh;\n  overflow-y: auto;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n.popover-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n  margin-bottom: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #333;\n}\n.popover-close {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: #999;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n.popover-close:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n.popover-body pre {\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 13px;\n  line-height: 1.7;\n  color: #444;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
